import { Realization, RealizationSubscribed } from "types/realization";

function isRealization(data: any): data is Realization {
        return data && typeof data === 'object' && '_id' in data && 'owner' in data && 'indicator' in data;
}

function isRealizationSubscribed(data: any): data is RealizationSubscribed {
    return data && typeof data === 'object' && '_id' in data && ('concorrentes_info' in data || 'concorrentes' in data) && 'realization' in data;
}

function clearRegistrationUser(player: string): string{
    return player.replace(/^F?(0+)?/gi,"").toString()
}
export {
    isRealization,
    isRealizationSubscribed,
    clearRegistrationUser
}